<div class="container">

  <img [src]="customization?.logoUrl"
    class="logo"
    [ngClass]="{logo_eq_s: size.equal('s')}">

    @if (size.more('s')) {
      <p>
        <span class="logo-title">
          {{ customization?.title || '' }}
        </span>
      </p>
    }

    @if (badge) {
      <div class="badge">{{ badge }}</div>
    }

  </div>
